<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        item_id: '',
        item_descricao: '',
        item_peso_bruto: '',
        item_peso_liquido: '',
        item_codigo_origem: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
      }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.item_descricao === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Codigo"
                label-for="item_id"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.item_id"
                    id="item_id"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite o id"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Descrição *"
                label-for="item_descricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.item_descricao"
                    id="item_descricao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Familia Comercial"
                label-for="familia_comercial_descricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Familia Comercial"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.familia_comercial.familia_comercial_descricao"
                    id="familia_comercial_descricao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Familia Material"
                label-for="familia_material_descricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Familia Material"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.familia_material.familia_material_descricao"
                    id="familia_material_descricao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Grupo Estoque"
                label-for="grupo_estoque_descricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Grupo Estoque"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.grupo_estoque.grupo_estoque_descricao"
                    id="grupo_estoque_descricao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Peso Bruto"
                label-for="item_peso_bruto"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Peso Bruto"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.item_peso_bruto"
                    id="item_peso_bruto"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Peso Liquido"
                label-for="item_peso_liquido"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Peso Liquido"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.item_peso_liquido"
                    id="item_peso_liquido"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Item Codigo Origem"
                label-for="item_codigo_origem"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Item Codigo Origem"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.item_codigo_origem"
                    id="item_codigo_origem"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Descrição *"
                label-for="item_descricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.item_descricao"
                    id="item_descricao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="dataForm.isDefault"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
